

var ecoIdKey ='eco-id-';
var ecoQtyKey ='eco-quantity-';

/** price match **/

function getPriceMatchInfo() {

  var policy = '<h4 class="pricematch-title">Price Match Guarantee</h4>';
  policy = policy + '<p>Get the best price possible when you shop at Coast Appliances. Our <a href="/pages/price-match-guarantee" target="_blank">Price Match Guarantee</a> ensures that if you find the same item advertised at a lower price – up to 30 days after your purchase – we will match or beat the price. Some terms apply.</p>';


  return policy;
}

function getPayBightPopupInfo(){
  var popoup = '<h4 class="pricematch-title">Financing with PayBright</h4>';
  popoup = popoup + '<p>PayBright’s payment plans allow you to split up the cost of a purchase into a series of monthly instalments, so you can buy now and pay later.</p>';


  return popoup;

}

function getFlexitiPopupInfo() {

  var popoup = '<h4 class="pricematch-title">Financing with Flexiti</h4>';
  popoup = popoup + '<p>Flexiti’s payment plans allow you to split up the cost of a purchase into a series of monthly instalments, so you can buy now and pay later.</p>';


  return popoup;

}

function SeriaizeFormWithArray(Form, productForm, productHandle=null) {
    //var obj =JSON.stringify(Form.serialize(productForm));
 // ClearSelectedProtectionPlan();
  	var jsonSerializedForm;
  	var serializedForm = Form.serialize(productForm);
  	// first loop to see if there is an eco fee added to the form
  	var ecoIdSerialized, echoQtySerialized;
  	var hasEco = false;
  	var bundleKey;
  	var idKey = 'id';
    var qtyKey = 'quantity';
  	var itemId, itemQty, ecoId, ecoQty;
  	var province = GetSelectedStoreProvince();

     for (var key in serializedForm) {
		if (serializedForm.hasOwnProperty(key)) {
         	if (key === ecoIdKey + province)
            {
              ecoIdSerialized = '"id":"' + serializedForm[key] + '",' ;
              ecoId = serializedForm[key];
              hasEco = true;
            }
          	if (key === ecoQtyKey + province)
            {
              /** fix so ecoQty always matches itemQTY **/
              if(typeof itemQty !== "undefined")
              {
                echoQtySerialized = '"quantity":"' + itemQty + '"';
              	ecoQty = itemQty;
              }
              else{
                echoQtySerialized = '"quantity":"' + serializedForm[key] + '"';
              	ecoQty = serializedForm[key];
              }
            }
          	if (key === idKey)
            {
              itemId = serializedForm[key];
            }
          	if (key === qtyKey)
            {
              itemQty = serializedForm[key];
              	/** fix so ecoQty always matches itemQTY **/
              if(typeof ecoQty !== "undefined")
              {
                echoQtySerialized = '"quantity":"' + serializedForm[key] + '"';
              	ecoQty = serializedForm[key];
              }
            }
        }
     }
  	 if (!hasEco)
     {
       jsonSerializedForm = JSON.stringify(serializedForm);
     }
    else
    {
      	bundleKey =  itemId + ":" + itemQty + "|" + ecoId + ":" + ecoQty;
        var handle = productHandle ? productHandle : GetProductHandle();
      	var itemProperties = GetProperties(bundleKey,handle, false, itemId);
      	var ecoProperties = GetProperties(bundleKey,handle, true, itemId);
		var tempjsonSerializedForm = JSON.stringify(serializedForm);
      	//console.log(tempjsonSerializedForm);
      	tempjsonSerializedForm = tempjsonSerializedForm.replace('{' ,  '{"items":[{');
      	tempjsonSerializedForm = tempjsonSerializedForm.replace('}',',"properties": {' + itemProperties + '}},{' + ecoIdSerialized + echoQtySerialized + ',"properties": {' + ecoProperties + '}' +'}]}');
      	//tempjsonSerializedForm = tempjsonSerializedForm.replace('}','},{' + ecoIdSerialized + echoQtySerialized + '}]}');
      	//tempjsonSerializedForm = tempjsonSerializedForm.replace('}',',properties: {' + itemProperties + '}},{' + ecoIdSerialized + echoQtySerialized + ,properties: {' + ecoProperties + '} +'}]}');
      	jsonSerializedForm = tempjsonSerializedForm;
        //console.log(jsonSerializedForm);

    }

    return jsonSerializedForm;
};

function GetProperties(bundleKey, handle, isFee, masterId)
{
  var _bundle_key = '"_bundle_key":"' + bundleKey + '",';
  var _master = '"_master":"' + handle + '",'
  var _masterId = '"_master_id":"' + masterId + '",'
  var _isFee = '"_is_fee":"' + isFee + '"'
  var properties = _bundle_key + _master + _masterId + _isFee;
  return properties;
}

/**
$(document).ready(function() {

  $('.product-item').each(function() {
    for (var i in productBadgeTags) {
      var tagname = productTags[i].tag;
       if ($(this).hasClass(tagname)) {
         if($(this).find(".promo-msg").length === 0) {
           	var promo = '<span class="promo-msg"><span class="' + productTags[i].class + '">' + productTags[i].tag_content + '</span></span>';
           	$(this).find(".product-item__title").after(promo);
         }
       }
    }

  });

});
**/
/**
(function( $ ){
   $.fn.LoadProductBadges = function() {

    $(this).find('.product-item').each(function() {
    for (var i in productBadgeTags) {
      var tagname = productTags[i].tag;
       if ($(this).hasClass(tagname)) {
         if($(this).find(".promo-msg").length === 0) {
           	var promo = '<span class="promo-msg"><span class="' + productTags[i].class + '">' + productTags[i].tag_content + '</span></span>';
           	$(this).find(".product-item__title").after(promo);
         }
       }
    }

  });
      return this;
   };
})( jQuery );


**/

/** promo messaging on pdp **/
$(document).ready(function() {
  var productTags = $('[data-product-tags-json]');
  var pdp_messaging_div = $('.pdp-promo-messaging');
  var pdp_v2_messaging_div = $('.pdp-v2-promo-messaging');
  var itemcss_v2 = '';
  var html = '';
  var itemcss = '';
  var index = 0;
  if (productTags.length > 0) {
    var rawContent = productTags[0].innerHTML;
    /* We need to do this for the dimension tags since there is a conflict with the double quote for inches */
    var cleanedContent = rawContent.replace(/(Width_|Height_|Depth_)(\d+)"/g, '$1$2\\"')
    var tags = JSON.parse(cleanedContent);
    for (var i in productBadgeTags) {
      index++;
      var itemclass = 'pdp_badge_' + index;
      for (var j in tags.tags) {
        if (productBadgeTags[i].tag.length > 0) {
        if (productBadgeTags[i].tag == tags.tags[j])
        {
          var ismodalEnabled = productBadgeTags[i].is_modal_enabled;
          var isLinkEnabled = productBadgeTags[i].is_link_enabled;
          var linkUR = productBadgeTags[i].url;
          html += '<div class="pdp_badge_item ' + itemclass + '">';
          if (ismodalEnabled)
          {
            html += '<button aria-expanded="false" aria-haspopup="true" data-action="open-modal" data-secondary-action="open-promo-badge-details" aria-controls="modal-pdp-badge-details" badge-id="'+ itemclass +'">';
          }
          else {
            if (isLinkEnabled && linkUR.length > 0)
             {
           		html += '<a href="' + linkUR + '" ';
               	if (productBadgeTags[i].link_onclick.trim().length > 0)
                {
                  html += 'onclick="' + productBadgeTags[i].link_onclick.trim() + ' return false;"';
                }
               	html += '>';
             }
          }
          html += '<span class="' + productBadgeTags[i].style + '-pdp" style="background:' +  productBadgeTags[i].background_color + ';color:' + productBadgeTags[i].text_color +'">' + productBadgeTags[i].badge_content + '</span>';
          if (ismodalEnabled){
            html += '<input type="hidden" id="pdp_badge_modal-content" value="'+ productBadgeTags[i].modal_content.replace(/"/g, "'") +'"/>';
            html += '</button>';
          }
          else {
            if (isLinkEnabled && linkUR.length > 0) {html += '</a>'; }
          }
          html += '</div>';
          //break;
          if (productBadgeTags[i].style == 'pdp_badge_style_tgr')
          {
          	itemcss += '<style> .' + itemclass + ' .pdp_badge_style_tgr-pdp::after{ border-left: 13px solid '+ productBadgeTags[i].background_color +'; } .' + itemclass + ' .pdp_badge_style_tgr-pdp::before{background: ' + productBadgeTags[i].text_color + '}</style>';
          }
          if (productBadgeTags[i].style == 'pdp_badge_style_tgl')
          {
          	itemcss += '<style> .' + itemclass + ' .pdp_badge_style_tgl-pdp::before{ border-right: 13px solid '+ productBadgeTags[i].background_color +'; } .' + itemclass + ' .pdp_badge_style_tgl-pdp::after{background: ' + productBadgeTags[i].text_color + '}</style>';
          }
        }
      }
     }
    }
    if (html.length > 0)
    {
      //this if statement is for v2 new pdp right column offer badges
      if (pdp_v2_messaging_div && pdp_v2_messaging_div.hasClass("hidden")) {
        pdp_v2_messaging_div.removeClass("hidden");
        pdp_v2_messaging_div.append(html);

        var pdpBadgeItems = document.querySelectorAll('.pdp_badge_item');
        pdpBadgeItems.forEach(function(parentElement) {
          var buttonElement = parentElement.querySelector('button');
          if (buttonElement) {
            var spanElement = buttonElement.querySelector('span');
            if (spanElement) {
              spanElement.removeAttribute('class');
              spanElement.classList.add('pad_badge_style-pdp-v2');
              const path = '//www.coastappliances.ca/cdn/shop/t/2549/assets/v-shape-icon.png?v=72603590260891190431756494732';
              var imgElement = document.createElement("img");
              imgElement.className = "v-shaped-icon";
              imgElement.loading = "lazy";
              imgElement.src = path;
              spanElement.append(imgElement);
            }
          }
        });
      }

    	pdp_messaging_div.append(html);
    	pdp_messaging_div.append(itemcss);
      	//pdp_messaging_div.after('<hr class="card__separator-coast">');
    }

  }
});


function LoadInStockBadge(param) {
    $(param).find('.product-item').each(function() {
    var productId = this.getAttribute('product-id');
    var badgeScript =  $(this).find('#Badge-InStock-Loader-' + productId);
      if (badgeScript.length > 0) {
          $('head').append(badgeScript[0].outerHTML);
          badgeScript[0].remove();
      }

  });
      return this;

};

function LoadPLPBadges(baseUrl, itemContainer)
{
  var sale_ends_date_enabled = true;
  var storeId = GetSelectedStoreId();
  var url = baseUrl + '?view=badgesajax&store_id='+ storeId + '&type=' + GetRandomInt(1,100) + '&cache=false&quantity='+ GetRandomInt(1,100);
  var jqueryContainer = $(itemContainer);
  var plpBadgesContainer = '<div class="product-item-badges-container-plp">';
  var productInfoElement = jqueryContainer.find(".isp_product_info");
  var maxLenghtOnTablet = 19;
  fetch(url).then(function (response) {
    response.text().then(function (content) {
      var badgesResponse = JSON.parse(content);
      var inStock = badgesResponse.instock;
      const inStockCanadaWide = badgesResponse.instock_canada_wide;
      var sale_end_date_display = badgesResponse.sale_end_date_display;
      var sale_end_date = badgesResponse.sale_end_date;
      var clearance_values = badgesResponse.clearance_values;
      let sale_price = badgesResponse.sale_price;
      /** Load Sale Ends Date **/
      if(sale_ends_date_enabled){
         if(sale_end_date){
          const sale_ends_date_formatted = new Date(sale_end_date);
          const current_date_formatted = new Date();
          if (current_date_formatted < sale_ends_date_formatted) {
            const hoursBetweenDates = GetHoursDifference(current_date_formatted, sale_ends_date_formatted);
            if(!productInfoElement.find('.isp_product_price_wrapper').hasClass('sale-ends-date-added')){
              if ( hoursBetweenDates > 24 && hoursBetweenDates < 48 ) {
                productInfoElement.find('.isp_product_price_wrapper').prepend(`<div class="plp-sale-ends-date" >Saving Ends: Tomorrow </div>`);
                productInfoElement.find('.isp_product_price_wrapper').addClass('sale-ends-date-added');
              }
            }
            if(!productInfoElement.find('.isp_product_price_wrapper').hasClass('sale-ends-date-added')){
              if ( hoursBetweenDates > 0 && hoursBetweenDates <= 24  ) {
                productInfoElement.find('.isp_product_price_wrapper').prepend(`<div class="plp-sale-ends-date" >Saving Ends: Today </div>`);
                productInfoElement.find('.isp_product_price_wrapper').addClass('sale-ends-date-added');
              }
            }
            if (!productInfoElement.find('.isp_product_price_wrapper').hasClass('sale-ends-date-added')){
              productInfoElement.find('.isp_product_price_wrapper').prepend(`<div class="plp-sale-ends-date" >Saving Ends: ${sale_end_date_display}</div>`);
              productInfoElement.find('.isp_product_price_wrapper').addClass('sale-ends-date-added');
            }
          }
         } else {
            if(productInfoElement.find('.isp_product_price_wrapper').length == 0){
                productInfoElement[0].style.marginTop = "3.5rem";
            } else {
              if (!productInfoElement.find('.isp_product_price_wrapper').hasClass('sale-ends-date-added')){
                productInfoElement.find('.isp_product_price_wrapper').prepend(`<div class="plp-sale-ends-date" style="visibility: hidden;" > &nbsp </div>`);
                productInfoElement.find('.isp_product_price_wrapper').addClass('sale-ends-date-added');
              }
            }
         }
      }

      /** Load Also Available On Clearance -- plp**/
      if(true){
        LoadClearanceModelAvailablePLP(clearance_values, productInfoElement, sale_price);
      }

	  // In stock badge
      if (inStock || inStockCanadaWide)
      {
        //var container = jqueryContainer.find(".isp_product_image_wrapper")
        if( jqueryContainer.find(".badge--instock-label-plp").length === 0) {
          const inStockCanadaWideClass = inStockCanadaWide ? 'instock-canada-wide' : '';
          productInfoElement.before(plpBadgesContainer + '<div class="badge--instock-container badge--plp-first-badge"><span class="badge--instock-label-plp ' + inStockCanadaWideClass + '">In stock</span></div></div>');
        }
      }
      else{
        //var container = jqueryContainer.find(".isp_product_image_wrapper")
        if( jqueryContainer.find(".badge--instock-label-plp").length === 0) {
          productInfoElement.before(plpBadgesContainer + '<div class="badge--instock-container"><span class="badge--instock-label-plp hidden">In stock</span></div></div>');
        }
      }
      var InStockBadgeContainer = jqueryContainer.find(".badge--instock-container");
     // Promotional badges
     if(jqueryContainer.find(".product-item-badge").length === 0) {
      var productBadgesClass = badgesResponse.plp_badge_classes;
      var hasPromoTag = false;
      var itemcss = '';
      var badgeContainer =  '<div class="product-item-badge">';
      var noBadge = badgeContainer + '<span class="item-no-badge-placeholder"></span></div>';
      var exitloop = false;
      var itemclass = 'plp_item_' + itemContainer.getAttribute('product_id');
      var badge = badgeContainer;
      if (productBadgesClass.length > 0) {
        try {
          var tags = JSON.parse(JSON.stringify(productBadgesClass));
          for (var i in productBadgeTags) {
            for (var j in tags) {
              var tagname = productBadgeTags[i].tag.replaceAll(' ', "-");
              if (productBadgeTags[i].tag.length > 0) {
                if(tagname == tags[j])
                {
                 /** if (productBadgeTags[i].badge_content.length > maxLenghtOnTablet)
                  {
                    //badge = '<div class="product-item-badge plp-hide-badge-on-tablet">';
                  } **/
                  if (productBadgeTags[i].style == 'pdp_badge_style_tgr' || productBadgeTags[i].style == 'pdp_badge_style_tgl')
                  {
                     badge =  '<div class="product-item-badge badge-hide-overflow">';
                  }
                  var isLinkEnabled = productBadgeTags[i].is_link_enabled;
                  var linkUR = productBadgeTags[i].url;
                  if (isLinkEnabled && linkUR.length > 0)
                  {
                     badge += '<a href="' + linkUR + '" ';
                     if (productBadgeTags[i].link_onclick.trim().length > 0)
                     {
                      badge += 'onclick="' + productBadgeTags[i].link_onclick.trim() + ' return false;"';
                     }
                      badge += '>';
                  }
                  badge += '<span class="' + productBadgeTags[i].style + '-plp" style="background:' +  productBadgeTags[i].background_color + ';color:' + productBadgeTags[i].text_color +'">' + productBadgeTags[i].badge_content + '</span>';
                  if (isLinkEnabled && linkUR.length > 0) {badge += '</a>'; }
                  badge += '</div>';
                  // add the badge to the element
                  InStockBadgeContainer.after(badge);
                  hasPromoTag = true;
                  if (productBadgeTags[i].style == 'pdp_badge_style_tgr')
                  {
                    jqueryContainer.addClass(itemclass);
                    itemcss += '<style> .' + itemclass + ' .pdp_badge_style_tgr-plp::after{ border-left: 13px solid '+ productBadgeTags[i].background_color +'; } .' + itemclass + ' .pdp_badge_style_tgr-plp::before{background: ' + productBadgeTags[i].text_color + '}</style>';
                  }
                  if (productBadgeTags[i].style == 'pdp_badge_style_tgl')
                  {
                    jqueryContainer.addClass(itemclass);
                    itemcss += '<style> .' + itemclass + ' .pdp_badge_style_tgl-plp::before{ border-right: 13px solid '+ productBadgeTags[i].background_color +'; } .' + itemclass + ' .pdp_badge_style_tgl-plp::after{background: ' + productBadgeTags[i].text_color + '}</style>';
                  }
                  if (itemcss.length > 0)
                  {
                   // add the css to the element
                   InStockBadgeContainer.after(itemcss);
                  }
                  exitloop = true;
                  break;
                }
              }
			}
            if (exitloop == true)
            {
             	break;
            }
          }
          if (hasPromoTag == false)
          {
            InStockBadgeContainer.after(noBadge);
          }

        }catch(err) {
 			console.log(err);
        }
      }
      else {
         InStockBadgeContainer.after(noBadge);
       }
     }
    });
  });

}

function showWarrantyBadge(warrantySelector, warrantyBadgeContainer) {
  setTimeout(() => {
    const warrantySelectorIndex = warrantySelector.find(':selected').index();
    warrantyBadgeContainer.find('.warranty-badge-container').hide();
    if(warrantySelectorIndex === 1) {
      warrantyBadgeContainer.find('.warranty-badge-recommended').show();
    } else if (warrantySelectorIndex === 2) {
      warrantyBadgeContainer.find('.warranty-badge-bestvalue').show();
    } else {
      warrantyBadgeContainer.find('.warranty-badge-hidden').show();
    }
  }, 500);
}

function getProductNextDayWarehouses(productInStockLocationListArray, nextDayWarehouses) {
  const warehouses = [];
  for (let i = 0; i < productInStockLocationListArray.length; i++) {
    if (nextDayWarehouses.includes(productInStockLocationListArray[i])) {
      warehouses.push(productInStockLocationListArray[i]);
    }
  }
  return warehouses;
}

function shouldShowNextDay(productInStockTagListArray) {
  const nextDayStoreWarehouseMappingJson = "{\n  \"190\": [\"141\", \"131\", \"181\", \"111\", \"121\"],\n  \"163\": [\"161\"],\n  \"173\": [\"171\"],\n  \"290\": [\"221\", \"211\"],\n  \"590\": [\"521\", \"511\"]\n}";
  if(!!nextDayStoreWarehouseMappingJson === false) {
    return false;
  }
  const nextDayStoreWarehouseMapping = JSON.parse(nextDayStoreWarehouseMappingJson);
  const productInStockLocationListArray = productInStockTagListArray.map(element => {
    const match = element.match(/\d+/);
    return match ? match[0] : null;
  });
  const nextDayWarehouses = Object.keys(nextDayStoreWarehouseMapping);
  const warehouses = getProductNextDayWarehouses(productInStockLocationListArray, nextDayWarehouses);
  const currentStoreId = GetSelectedStoreId();
  const isNextDayDelivery = warehouses.some(warehouse => nextDayStoreWarehouseMapping[warehouse].includes(currentStoreId.toString()));

  return isNextDayDelivery;
}

function LoadNextDayDeliveryBadge(param) {
  $(param).find('.product-item').each(function() {
    var productId = this.getAttribute('product-id');
    var badgeScript =  $(this).find('#next-day-delivery-badge-loader-' + productId);
    if (badgeScript.length > 0) {
      $('head').append(badgeScript[0].outerHTML);
      badgeScript[0].remove();
    }
  });
  return this;
};

function LoadCoastRecommendsBadge(param) {
  $(param).find('.product-item').each(function() {
    var productId = this.getAttribute('product-id');
    var badgeScript =  $(this).find('#coast-recommends-badge-loader-' + productId);
    if (badgeScript.length > 0) {
      $('head').append(badgeScript[0].outerHTML);
      badgeScript[0].remove();
    }
  });
  return this;
};

function getLocationMetadata(storeId, quickShipMetadata){

  const locationMetadata = quickShipMetadata.find(location => parseInt(location.location_id) === storeId);
  locationMetadata.shipping_tier = parseInt(locationMetadata.shipping_tier);
  return locationMetadata;

};
